module.exports = __webpack_public_path__ + "static/media/ImagineInternet_TOS_2019.6e8151b3.pdf";